import { render, staticRenderFns } from "./ScrollUpButton.vue?vue&type=template&id=2c35c01d&scoped=true"
import script from "./ScrollUpButton.vue?vue&type=script&lang=ts"
export * from "./ScrollUpButton.vue?vue&type=script&lang=ts"
import style0 from "./ScrollUpButton.vue?vue&type=style&index=0&id=2c35c01d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35c01d",
  null
  
)

export default component.exports